<template>
    <div>
            <b-list-group-item>
                <b-form>
                    <b-form-group id="input-group-1-passivecheck" label="Status:"
                                  label-for="input-passive">
                        <b-form-select
                            id="input-passive"
                            v-model="checkForm.state"
                            :options="checkForm.options"
                            required
                        ></b-form-select>
                    </b-form-group>
                    <b-form-group
                        id="input-group-1-passiveCheck"
                        :label="$t('forms.message')"
                        label-for="textarea-passive">
                        <b-form-textarea v-model="v$.checkForm.comment.$model"
                                         :class="{ 'is-invalid': v$.checkForm.$error }"
                                         id="textarea-passive"
                                         placeholder="Comment for passive check"
                                         rows="3"
                                         max-rows="6"
                        ></b-form-textarea>
                        <div class="invalid-feedback" v-if="v$.checkForm.comment.required">{{ $t('Field is required') }}
                        </div>
                    </b-form-group>
                    <b-form-group id="input-group">
                        <b-form-checkbox
                            v-model="checkForm.forceHardstate"
                            id="checkboxes-custom-notification"
                            name="checkboxes-custom-notification"
                        >
                            Force to hard State
                        </b-form-checkbox>
                    </b-form-group>
                    <b-button variant="success" @click="passiveCheck" class="w-100">{{ $t('forms.send-command') }}
                    </b-button>
                </b-form>
            </b-list-group-item>
    </div>
</template>

<script>
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { useToast } from "vue-toastification";

export default {
    name: "HostPassiveCheck",
    props: [
        'hostuuid',
    ],
    data(){
        return {
            checkForm: {
                state: 0,
                options: [
                    {value: 0, text: 'up'},
                    {value: 1, text: 'down'},
                    {value: 2, text: 'unreachable'},
                ],
                comment: null,
                forceHardstate: false,
            },
        }
    },
    setup: () => ({ v$: useVuelidate() }),
    validations: {
        checkForm: {
            comment: {
                required,
            }
        }
    },
    methods: {
        async passiveCheck(){
            this.v$.checkForm.$touch();
            const isFormCorrect = await this.v$.checkForm.$validate()
            if(!isFormCorrect){
                return;
            }
            let externalCommands = [];
            externalCommands.push({
                command: 'commitPassiveResult',
                hostUuid: this.hostuuid,
                status_code: this.checkForm.state,
                plugin_output: this.checkForm.comment,
                forceHardstate: this.checkForm.forceHardstate,
                maxCheckAttempts: 10

            });
            this.sendCommand(externalCommands);
        },
        sendCommand: function(externalCommands){
            axios.post('/hosts/external_commands.json', externalCommands)
                .then(response => {
                    useToast().success(this.$t('Command successfully sent'), {
                        timeout: 7000
                    });
                    this.$emit('refresh', 'togglePassiveColapse');
                })
                .catch(error => {
                    useToast().error(this.$t('error'), {
                        timeout: 2000
                    });
                });
        },
    }
}
</script>

<style scoped>

</style>
